var render, staticRenderFns
import script from "./gaode_district_area.vue?vue&type=script&lang=js"
export * from "./gaode_district_area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43dbf315')) {
      api.createRecord('43dbf315', component.options)
    } else {
      api.reload('43dbf315', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/gaode_district_area/gaode_district_area.vue"
export default component.exports